import { Route, Routes } from "react-router-dom";
import Prime from "./Prime";
import ContactUs from "./components/banner/ContactUs";
import Footer from "./components/footer";
import Header from "./components/header";
import AboutUs from "./pages/aboutus";
import AcademicEnglish from "./pages/academicenglish";
import Admission from "./pages/admission";
import AllCourses from "./pages/allcourses";
import Careers from "./pages/career";
import CareerDevelopment from "./pages/careerdevelopment";
import Contact from "./pages/contact";
import EnglishWriting from "./pages/englishwriting";
import FreeSeminar from "./pages/freeSeminar";
import Ielts from "./pages/ielts";
import IeltsMockTest from "./pages/ieltsmocktest";
import MsOffice from "./pages/msoffice";
import PhoneticsForeignAccent from "./pages/phonetics";
import SiteMap from "./pages/siteMap";
import SpokenEnglish from "./pages/spokenenglish";

function App() {
  return (
    <div className="w-full h-auto mx-auto bg-white relative overflow-hidden">
      <Header />
      <Routes>
        <Route path="/" element={<Prime />}></Route>
        <Route path="/courses" element={<AllCourses />}></Route>
        <Route path="/contactus" element={<Contact />}></Route>
        <Route path="/aboutus" element={<AboutUs />}></Route>
        <Route path="/careers" element={<Careers />}></Route>
        <Route path="/admission" element={<Admission />}></Route>
        <Route path="/allcourses" element={<AllCourses />}></Route>
        <Route path="/spokenenglish" element={<SpokenEnglish />}></Route>
        <Route path="/academicenglish" element={<AcademicEnglish />}></Route>
        <Route path="/englishwriting" element={<EnglishWriting />}></Route>
        <Route path="/ielts" element={<Ielts />}></Route>
        <Route path="/ieltsmocktest" element={<IeltsMockTest />}></Route>
        <Route path="/phonetics" element={<PhoneticsForeignAccent />}></Route>
        <Route path="/msoffice" element={<MsOffice />}></Route>
        <Route path="/freeseminar" element={<FreeSeminar />}></Route>
        <Route path="/sitemap" element={<SiteMap />}></Route>
        <Route
          path="/careerdevelopment"
          element={<CareerDevelopment />}
        ></Route>
      </Routes>
      <ContactUs />
      <Footer />
    </div>
  );
}
export default App;
